import classNames from 'classnames';
import React from 'react';
import { useTPAComponentsContext } from 'wix-ui-tpa/cssVars';
import { getGridStyle } from './grid-options';
import styles from './grid.scss';
import { classes } from './grid.st.css';
export const Grid = _ref => {
  let {
    items,
    layout,
    isRTL
  } = _ref;
  const {
    mobile
  } = useTPAComponentsContext();
  const reactElementsByRow = getReactElementsByRow(items);
  return /*#__PURE__*/React.createElement("div", {
    className: classNames(styles.container, classes.flexboxContainer),
    dir: isRTL ? 'rtl' : ''
  }, reactElementsByRow.map((elements, index) => {
    var _elements$;
    const key = mobile && ((_elements$ = elements[0]) == null || (_elements$ = _elements$.props) == null || (_elements$ = _elements$.field) == null ? void 0 : _elements$.id) || index;
    return /*#__PURE__*/React.createElement("div", {
      key: key,
      style: getGridStyle({
        layout
      }),
      className: classNames(styles.grid, classes.column)
    }, elements);
  }));
};
function getReactElementsByRow(items) {
  const reactElementsByRow = items.reduce((result, item) => {
    const row = item.layout.row;
    const element = /*#__PURE__*/React.cloneElement(item.component, {
      key: item.id
    });
    if (result[row]) {
      result[row].push(element);
    } else {
      result[row] = [element];
    }
    return result;
  }, []);
  return reactElementsByRow;
}
//# sourceMappingURL=grid.js.map